module.exports = "<top-menu></top-menu>\n<div class=\"full\">\n  <router-outlet></router-outlet>\n</div>\n<!--\n\nfirebase functions:config:set credit-card.token=\"Ysk_live_TuhZHjFCAeZu6hrmZP4dYsr6\"\n\n\n-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main